var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_729_991",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_729_991",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAlVJREFUaIHtmtFx2zAMhr/08h51AmuDaoNqBG3QblBvEGeDZIK4E8Qb1N3AncD2BFYnSB9I3sEyRYGUKsWJ/juczzIBEhQE/IQMV44bxZivLdd/D7mQVDQdyIAfQAUUShs7YAM8AbVSJwO+2c8U1MDP5nw5sAdeE2VvbWiw7jGPkzXAJ2H0OWIBPuTWhgapO39h49Z+KYBS/HjEhMWW9rDIrE4FLOy10tradUy+kotIQC1sALDk/PZo4x87VuouExeVBBdCcif+0r2DEjur4zBEeKjhHJCxH7N4n06f5ygaPgf6YhIHrhazA1PDOaClAG8OzgGZRRa+gR2QOtv05cTj1nMtx+TyGGKWknkK4C5BDzy1quS8mr6gq8aFHSt1y6CGwYr+ZG7VNFoHBp+AX1ZOgXHau7YdwIGLUK0GMFopHagIb1iX1G1zlcAhweABXegMjrYjZW6loJ2c1ZgH6WBlxowZMz4gQml0gS6NHnlDabQkrbm1Z6JCJjE2lQhxqi45+eYKGTxgyNOWMNU4KR0YnMw16fQGHcfP7VipOyqdvhEG78UEn4k70Midf8DD1T0IJYguuATiPZEdiTsj11Yn9iia0kC7gDsTy9uekhKlzqjZ6N20Va4WswNTwzkwJJcZlRf5HPiSYEfqTOKAzPsZ8a+YZEEatc/qClmzSfSCoQiu6+CD61o0SZWmN1pgKn+fSvxAoxj+l25ZC5r8KUU2cJ6FvmMoQSqO1oYGQ4RZDf6/GiwxYaF9mP9gduMxYmEZxtk+IbQGas2fPdq4zajvAd4t/gH4aG3f93/GEgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryLogo);
export default __webpack_public_path__ + "static/media/categoryLogo.b61242e7263bc184b5a8867d435fba83.svg";
export { ForwardRef as ReactComponent };